import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {
  AlertsServiceSchedular_create,
  AlertsServiceSchedular_update,
  AlertsServiceSchedular_delete,
  AlertsServiceSchedular_readById,
  AlertsServiceSchedular_readAll,
  AlertsServiceSchedular_readByServiceId
} from 'src/app/GlobalVariables';

import {
  AlertsServiceSchedularCreateRequestDTO,
  AlertsServiceSchedularUpdateRequestDTO,
  AlertsServiceSchedularDeleteRequestDTO,
  AlertsServiceSchedularReadByIdRequestDTO,
  AlertsServiceSchedularDTO,
  AlertsServiceSchedularList,
  AlertsServiceSchedularReadByServiceIdRequestDTO
} from './alertsServiceSchedular.interface';

@Injectable({
  providedIn: 'root'
})
export class AlertsServiceSchedularService {
  constructor(private http: HttpClient) {}

  AlertsServiceSchedular_create(data: AlertsServiceSchedularCreateRequestDTO): Observable<AlertsServiceSchedularDTO> {
    return this.http.post<AlertsServiceSchedularDTO>(AlertsServiceSchedular_create, data);
  }

  AlertsServiceSchedular_update(data: AlertsServiceSchedularUpdateRequestDTO): Observable<AlertsServiceSchedularDTO> {
    return this.http.post<AlertsServiceSchedularDTO>(AlertsServiceSchedular_update, data);
  }

  AlertsServiceSchedular_delete(data: AlertsServiceSchedularDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(AlertsServiceSchedular_delete, data);
  }

  AlertsServiceSchedular_readById(data: AlertsServiceSchedularReadByIdRequestDTO): Observable<AlertsServiceSchedularDTO> {
    return this.http.post<AlertsServiceSchedularDTO>(AlertsServiceSchedular_readById, data);
  }

  AlertsServiceSchedular_readAll(): Observable<AlertsServiceSchedularList> {
    return this.http.get<AlertsServiceSchedularList>(AlertsServiceSchedular_readAll);
  }

  AlertsServiceSchedular_readByServiceId(data: AlertsServiceSchedularReadByServiceIdRequestDTO): Observable<AlertsServiceSchedularList> {
    return this.http.post<AlertsServiceSchedularList>(AlertsServiceSchedular_readByServiceId, data);
  }
}
